import type { AdminTeamPreassignment, TeamPreassignment } from './types';

export function normalizePreassignment(
  row: TeamPreassignment | AdminTeamPreassignment
): TeamPreassignment {
  return {
    status: 'pending',
    failureReason: null,
    claimedAt: null,
    claimedByUserId: null,
    ...row,
  };
}

// Only the old single-email schema's explicit validation rejection proves
// that no batch writes happened. Network/server errors must never trigger replay.
export function isUnsupportedPreassignmentBatch(error: unknown): boolean {
  const response = (error as { response?: { status?: number; data?: { detail?: unknown } } })
    ?.response;
  const detail = response?.data?.detail;
  return (
    response?.status === 422 &&
    Array.isArray(detail) &&
    detail.some(
      issue =>
        issue.type === 'missing' &&
        Array.isArray(issue.loc) &&
        issue.loc.length === 2 &&
        issue.loc[0] === 'body' &&
        issue.loc[1] === 'email'
    )
  );
}
